exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".two-dimensional-video__main{background:#f6f6f6}.two-dimensional-video__control-panel{min-width:485px}\n", ""]);
